import React, { useEffect, useState } from "react";
import { Combobox, Option, Text, Button, Body1Strong } from "@fluentui/react-components";
import { WidgetProps } from "@rjsf/utils";
import moment from "moment-timezone";
import { Dismiss12Regular } from "@fluentui/react-icons";
import { Stack, StackItem } from "@fluentui/react";
import { dropdownDataStyle } from "../../styles/customStyles";

const TimezoneSelectWidget = (props: WidgetProps) => {
  const [filteredOptions, setFilteredOptions] = useState<string[]>([]);
  const [selectedOption, setSelectedOption] = useState<string>(props.value || "");

  useEffect(() => {
    const timezones = moment.tz.names();
    setFilteredOptions(timezones);
  }, []);

  useEffect(() => {
    if (props.value) {
      setSelectedOption(props.value);
    }
  }, [props.value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilteredOptions(
      moment.tz.names().filter((timezone) =>
        timezone.toLowerCase().includes(searchTerm)
      )
    );
  };

  const handleSelect = (event: any, option: any) => {
    if (option.optionText === "Clear selection") {
      setSelectedOption("");
      props.onChange("");
    } else {
      setSelectedOption(option.optionText);
      props.onChange(option.optionText);
    }
  };

  const handleClearSelection = () => {
    setSelectedOption("");
    props.onChange("");
  };

  
  return (
    <>
      <Stack tokens={{childrenGap:2}}>
        <StackItem>
        <Text><Body1Strong>{props.label}</Body1Strong></Text>
        </StackItem>  
        <StackItem>{selectedOption && (
          <Button
              size="small"
              shape="circular"
              appearance="primary"
              id={`${selectedOption}-remove`}
              aria-labelledby={`${selectedOption}-remove`}
              onClick={handleClearSelection}
              disabled={props?.disabled ? true : false}
            >
              {selectedOption}
              <Dismiss12Regular
                id={`${selectedOption}-remove`}
                aria-labelledby={`${selectedOption}-remove`}
              />
            </Button>
          )}
        </StackItem>
        <StackItem id="multistring">
          <Combobox
            id="timezone-combobox" 
            placeholder="Select a timezone"
            selectedOptions={selectedOption ? [selectedOption] : []}
            onOptionSelect={handleSelect}
            onChange={handleInputChange}
            disabled={props?.disabled ? true : false}
          >
            <div style={dropdownDataStyle}>
              <Option key="clear-selection" text="Clear selection">
                Clear selection
              </Option>
              {filteredOptions.map((timezone) => (
                <Option key={timezone} text={timezone}>
                  {timezone}
                </Option>
              ))}
            </div>
          </Combobox>
        </StackItem>
        </Stack>
    </>
  );
};

export default TimezoneSelectWidget;
